import { render, staticRenderFns } from "./ImporterFrame.vue?vue&type=template&id=b14bd814&scoped=true"
import script from "./ImporterFrame.vue?vue&type=script&lang=js"
export * from "./ImporterFrame.vue?vue&type=script&lang=js"
import style0 from "./ImporterFrame.vue?vue&type=style&index=0&id=b14bd814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14bd814",
  null
  
)

export default component.exports